<!-- Top Bar -->
<!-- FIXME: TODO: post threads: loading skeletons -->
<div
  *ngIf="currentPost"
  style="padding-bottom: 20vh"
  class="d-flex flex-column"
>
  <div
    class="global__top-bar d-flex align-items-center justify-content-between fs-18px font-weight-bold px-15px border-bottom border-color-grey"
    *ngIf="!hideHeader"
  >
    <div class="d-flex align-items-center">
      <top-bar-mobile-navigation-control
        class="mr-15px d-lg-none d-inline-block"
      ></top-bar-mobile-navigation-control>

      <div>Thread with {{ currentPost.ProfileEntryResponse.Username }}</div>
    </div>
  </div>

  <div class="global__top-bar__height" *ngIf="!hideHeader"></div>

  <div *ngFor="let parentPost of currentPost.ParentPosts">
    <!--  afterCommentCreatedCallback explanation: Here, the "post" is a top-level post. A new comment on a -->
    <!--  top-level post should be prepended to the post's list of comments -->
    <feed-post
      [post]="parentPost"
      [includePaddingOnPost]="true"
      [contentShouldLinkToThread]="true"
      [afterCommentCreatedCallback]="
        updateCommentCountAndShowToast.bind(this, parentPost)
      "
      [isParentPostInThread]="true"
      [showThreadConnectionLine]="true"
      [blocked]="isPostBlocked(parentPost)"
      (postDeleted)="onPostHidden(currentPost, null, null)"
      (userBlocked)="afterUserBlocked($event)"
    ></feed-post>
  </div>

  <div class="border-bottom border-color-grey" *ngIf="!hideCurrentPost">
    <!--  afterCommentCreatedCallback explanation: Here, the "post" is a top-level post. A new comment on a -->
    <!--  top-level post should be prepended to the post's list of comments -->
    <feed-post
      [post]="currentPost"
      [includePaddingOnPost]="true"
      [contentShouldLinkToThread]="true"
      [afterCommentCreatedCallback]="
        prependToCommentList.bind(this, currentPost)
      "
      [isParentPostInThread]="true"
      [showLeftSelectedBorder]="true"
      [showInteractionDetails]="true"
      [blocked]="isPostBlocked(currentPost)"
      (postDeleted)="onPostHidden(currentPost, null, null)"
      (userBlocked)="afterUserBlocked($event)"
    ></feed-post>
  </div>

  <div class="post-thread__comment-container">
    <div #uiScroll *uiScroll="let item of datasource">
      <div class="border-bottom border-color-grey">
        <!--  afterCommentCreatedCallback explanation: Here, the "post" is a comment. A new comment on a -->
        <!--  comment ("original comment") should be prepended to the original comment's list of comments (i.e. subcomments).-->
        <feed-post
          *ngIf="item.ProfileEntryResponse != null"
          [includePaddingOnPost]="true"
          [post]="item"
          [parentPost]="currentPost"
          [contentShouldLinkToThread]="true"
          [showIconRow]="true"
          [showReplyingToContent]="true"
          [afterCommentCreatedCallback]="
            prependToSubcommentList.bind(this, item, currentPost)
          "
          [blocked]="isPostBlocked(item)"
          (postDeleted)="onPostHidden(item, currentPost, null)"
          (userBlocked)="afterUserBlocked($event)"
        ></feed-post>

        <div *ngFor="let subcommentPost of item.Comments">
          <div
            class="px-15px pb-15px post-thread__subcomment-container"
            *ngIf="!isPostBlocked(item)"
          >
            <!--  afterCommentCreatedCallback explanation: Here, the "post" is a subcomment. A new comment on a -->
            <!--  subcomment should be appended to the parent (commentPost)'s list of subComments.-->
            <feed-post
              class="p-15px"
              *ngIf="subcommentPost.ProfileEntryResponse != null"
              [includePaddingOnPost]="true"
              [post]="subcommentPost"
              [parentPost]="item"
              [contentShouldLinkToThread]="true"
              [showIconRow]="false"
              [showDropdown]="false"
              [showReplyingToContent]="false"
              [isSubcomment]="true"
              [afterCommentCreatedCallback]="
                appendToSubcommentList.bind(this, item, currentPost)
              "
              [blocked]="isPostBlocked(subcommentPost)"
              (postDeleted)="onPostHidden(subcommentPost, item, currentPost)"
              (userBlocked)="afterUserBlocked($event)"
            ></feed-post>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
